import { useEffect, useState } from 'react';
import { Form, Input, Button, Typography, notification } from 'antd';
import { getCustomerData, UpdateCustomerInfo } from '../../../store/common/commonAsyncAction';
import { useDispatch, useSelector } from 'react-redux';

interface Props {
    title?: string;
    data?: any;
}

const ShippingAddressInfo = (props: Props) => {
    const customerData = useSelector((state: any) => state.common.customerData)
    const loginResp = useSelector((state: any) => state.user.userSession);
    const [shippingAddressLine1, setshippingAddressLine1] = useState("")
    const [shippingAddressLine2, setshippingAddressLine2] = useState("")
    const [shippingAddressLine3, setshippingAddressLine3] = useState("")
    const [shippingCityOrTown, setshippingCityOrTown] = useState("")
    const [shippingPostCode, setshippingPostCode] = useState("")
    const [shippingCountry, setshippingCountry] = useState("")
    const [shippingCounty, setshippingCounty] = useState("")
    const [customerId, setCustomerId] = useState("")
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    const failed = () => {
        console.log("FAiled:")
    }
    useEffect(() => {
        if (props.data) {
            setCustomerId(props?.data?.id)
            setshippingAddressLine1(customerData?.shippingAddressLine1)
            setshippingAddressLine2(customerData?.shippingAddressLine2)
            setshippingAddressLine3(customerData?.shippingAddressLine3)
            setshippingCityOrTown(customerData?.shippingCityOrTown)
            setshippingPostCode(customerData?.shippingPostCode)
            setshippingCountry(customerData?.ShippingCountry ?? customerData?.shippingCountry)
            setshippingCounty(customerData?.shippingCounty)
        }
    }, [])
    const handleSave = async (formdata: any) => {
        console.log("Sucess :")
        var params = {...customerData};
        setLoading(true)
        params.shippingAddressLine1 = formdata.shippingAddressLine1;
        params.shippingAddressLine2 = formdata.shippingAddressLine2;
        params.shippingAddressLine3 = formdata.shippingAddressLine3;
        params.shippingCityOrTown = formdata.shippingCityOrTown;
        params.shippingCounty = formdata.shippingCounty;
        params.ShippingCountry = formdata.country;
        params.shippingPostCode = formdata.shippingPostCode;
        if (
            params.shippingAddressLine1 === customerData.shippingAddressLine1 &&
            params.shippingAddressLine2 === customerData.shippingAddressLine2 &&
            params.shippingAddressLine3 === customerData.shippingAddressLine3 &&
            params.shippingCityOrTown === customerData.shippingCityOrTown &&
            params.shippingCounty === customerData.shippingCounty &&
            params.ShippingCountry === customerData.shippingCountry &&
            params.shippingPostCode === customerData.shippingPostCode
        ) {
            notification.open({
                message: '',
                description:'Profile  Updated Successfully',
                placement:"bottomRight"
            });
            setLoading(false)
            return;
        }
        try {
             await dispatch(UpdateCustomerInfo(params))
            notification.open({
                message: '',
                description:'Profile  Updated Successfully',
                placement:"bottomRight"
            });
            //     className: 'custom-class',
            //     style: {
            //       width: 400,
            //       marginTop:'40px'
            //     },
            //   });
           
            const query = `?customerId=${loginResp.userId}&customerEmail=${loginResp.email}`

            await dispatch(getCustomerData(query))
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const { title } = props;

    return (
        <div className="user-profile">
            <Typography.Title className="setting-tab-heading" level={4} >{title} </Typography.Title>
            <Form name="basic" layout="vertical"
                initialValues={{
                    shippingAddressLine1: customerData?.shippingAddressLine1,
                    shippingAddressLine2: customerData?.shippingAddressLine2,
                    shippingAddressLine3: customerData?.shippingAddressLine3,
                    shippingCityOrTown: customerData?.shippingCityOrTown,
                    shippingPostCode: customerData?.shippingPostCode,
                    country: customerData?.ShippingCountry ?? customerData?.shippingCountry ,
                    shippingCounty: customerData?.shippingCounty
                }} onFinish={handleSave} onFinishFailed={failed}
            >

                <Form.Item label="Address Line 1" name="shippingAddressLine1"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Address Line1!',
                        },
                    ]}
                >
                    <Input placeholder="1286 Randolph Street Northwest 12123" />
                </Form.Item>
                <Form.Item label="Address Line 2" name="shippingAddressLine2"
                    rules={[
                        {
                            required: true,
                            message: "Please Input Your AddressLine2",
                        }
                    ]}
                >
                    <Input placeholder="1286 Randolph Street Northwest 12123" />
                </Form.Item>
                <Form.Item label="Address Line 3" name="shippingAddressLine3"
                    rules={[
                        {
                            required: true,
                            message: "Please Input Your AdressLine3",
                        }
                    ]}
                >
                    <Input placeholder="1286 Randolph Street Northwest 12123" />
                </Form.Item>
                <Form.Item label="City/Town" name="shippingCityOrTown"
                    rules={[
                        {
                            required: true,
                            message: "Please Input Your City/Town"

                        }
                    ]}>
                    <Input placeholder="Washington" />
                </Form.Item>
                <Form.Item label="Post Code" name="shippingPostCode"
                    rules={[
                        {
                            required: true,
                            message: "Please Input Your Post Code"

                        }
                    ]}>
                    <Input placeholder="20011" />
                </Form.Item>
                <Form.Item label="Country" name="country"
                    rules={[
                        {
                            required: true,
                            message: "Please Input Your Country"

                        }
                    ]}>
                    <Input placeholder="20011" />
                </Form.Item>
                <Form.Item label="County" name="shippingCounty"
                    rules={[
                        {
                            required: true,
                            message: "Please Input Your County"

                        }
                    ]}>
                    <Input placeholder="20011" />
                </Form.Item>
           

            <Form.Item
                className="form-btn"
            >
                <Button type="primary" htmlType="submit" loading={loading}>
                    Submit
                </Button>
            </Form.Item>
            </Form>
        </div >
    )
}

export default ShippingAddressInfo;